/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint no-confusing-arrow: 0 */

import { combineReducers } from 'redux';
import { routerReducer as router, routerActions } from 'react-router-redux';
import { UserAuthWrapper as authWrapper } from 'redux-auth-wrapper';

import login from './modules/login';

import company from './modules/company';
import activity from './modules/activity';
import project from './modules/project';
import person from './modules/person';
import task from './modules/task';
import staff from './modules/staff';
import file from './modules/file';
import note from './modules/note';
import options from './modules/options';
import notification from './modules/notification';
import totaldata from './modules/totaldata';
import support from './modules/support';
import serviceKey from './modules/servicekey';
import serviceType from './modules/servicetype';
import numberRange from './modules/numberrange';
import objectNumber from './modules/objectnumber';
import feedback from './modules/feedback';
import limits from './modules/limits';
import settings from './modules/settings';
import profileSettings from './modules/profilesettings';

const loginInitialState = {
  fetching: false,
  isAuthenticated: false,
  validUntil: 0,
  token: null,
  user: {},
  staff: {},
  simplAccount: '',
};

export const userReducer = (state = loginInitialState, { type, payload }) => {
  if (type === 'USER_LOGGED_IN') {
    return payload;
  }
  if (type === 'USER_LOGGED_OUT') {
    return {};
  }
  return state;
};

// might be interesting
// https://github.com/davezuko/react-redux-starter-kit/issues/794
export const makeRootReducer = asyncReducers =>
  combineReducers({
    // Add sync reducers here
    router,
    login,
    company,
    activity,
    project,
    person,
    staff,
    task,
    file,
    note,
    notification,
    options,
    totaldata,
    support,
    serviceType,
    serviceKey,
    numberRange,
    objectNumber,
    feedback,
    limits,
    settings,
    profileSettings,
    ...asyncReducers,
    // user: userReducer, //this one should get removed at some point
  });

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export const UserIsAuthenticated = authWrapper({
  authSelector: state =>
    state.login && state.login.isAuthenticated ? state.login : null, // how to get the user state
  redirectAction: routerActions.replace, // the redux action to dispatch for redirect
  wrapperDisplayName: 'UserIsAuthenticated', // a nice name for this auth check
});

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js